module.exports = __webpack_public_path__ + "static/media/delcomar.97bd60b8.svg";